/**
 * Returns appropriate NR app and agent ID based on environment
 * Local account (772349144) for: development, undefined, preview
 * Production account (772289984) for: production
 * Staging account (772289986) for: staging
 */
const isStaging = process.env.environment === 'staging';

const getNrAppAgentID = () => {
  switch (process.env.environment) {
    case 'production':
      return '772289984';
    case 'staging':
      return '772289986';
    case 'preview':
    default:
      // Localhost, development, preview, or any undefined environment
      return '772349144';
  }
};

const siteConfig = {
  // Temporarily define a build as current plus.walmart or walmart.com/getplus
  buildType: (process.env.NEXT_PUBLIC_BUILD_TYPE === 'get-plus'
    ? 'get-plus'
    : 'standard') as 'get-plus' | 'standard',
  // Define Volt URls for _document.tsx: we avoid vtc cookie issues by not using WM proxy URLs
  baseVoltUrls: {
    'get-plus': {
      production: 'https://walmart.aws.reddigital.tech',
      staging: 'https://walmart-stg.aws.reddigital.tech',
    },
    standard: {
      production: 'https://plus.walmart.aws.reddigital.tech',
      staging: 'https://plus.walmart-stg.aws.reddigital.tech',
    },
  },
  beaconBdValues: {
    'get-plus': {
      production: 'b.www.walmart.com',
      staging: 'b.www-teflon.walmart.com',
    },
    standard: {
      production: 'beacon.walmart.com',
      staging: 'beacon.qa.walmart.com',
    },
  },
  beaconBhValues: {
    production: 'beacon.lightest.walmart.com',
    staging: 'beacon.qa.lightest.walmart.com',
  },
  // Monarch values used in _document.tsx
  monarch: {
    sourceId: '13823972-6eef-438b-86ef-c6d2023ffc71',
    clientToken: 'ae0a7e90-9367-4a9b-aedd-04e7592d6e42',
  },
  // Defines new relic values based on environment
  newRelic: {
    accountID: isStaging ? '3767832' : '3767831',
    agentAppID: getNrAppAgentID(),
    licenseKey: isStaging
      ? 'NRBR-d8218942a368b955b7e'
      : 'NRBR-5749a64f9542a1b0b04',
    sourcemapUploadKey: 'NRAK-CFV0VQIL4OT7F11T9AIHQSGM0BO',
  },
};

export default siteConfig;
